import { Badge } from "@/components/ui/badge";
import { Flame, Thermometer, Snowflake, HelpCircle } from "lucide-react";

const STATUS_COLORS = {
  emerald: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  blue: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  amber: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  purple: "bg-purple-500/10 text-purple-400 border-purple-500/30",
  green: "bg-green-500/15 text-green-300 border-green-400/40",
  red: "bg-red-500/10 text-red-400 border-red-500/30",
  slate: "bg-slate-500/10 text-slate-400 border-slate-500/30",
};

export function StatusBadge({ status, colorToken = "slate", testid }) {
  const cls = STATUS_COLORS[colorToken] || STATUS_COLORS.slate;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls}`}
    >
      {status}
    </span>
  );
}

const TEMP = {
  HOT: { cls: "bg-red-500/15 text-red-300 border-red-500/40", Icon: Flame },
  WARM: { cls: "bg-amber-500/15 text-amber-300 border-amber-500/40", Icon: Thermometer },
  COLD: { cls: "bg-blue-500/15 text-blue-300 border-blue-500/40", Icon: Snowflake },
  UNCLASSIFIED: { cls: "bg-slate-500/10 text-slate-400 border-slate-500/30", Icon: HelpCircle },
};

export function TemperatureBadge({ temp = "UNCLASSIFIED" }) {
  const { cls, Icon } = TEMP[temp] || TEMP.UNCLASSIFIED;
  return (
    <span
      data-testid={`temperature-badge-${temp}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${cls}`}
    >
      <Icon className="h-3 w-3" />
      {temp}
    </span>
  );
}

export function StatCard({ label, value, icon: Icon, accent = "text-primary", testid }) {
  return (
    <div data-testid={testid} className="glass rounded-xl p-5 animate-fade-up">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-wider text-muted-foreground">{label}</span>
        {Icon && <Icon className={`h-4 w-4 ${accent}`} />}
      </div>
      <div className="mt-3 text-3xl font-heading font-extrabold text-foreground font-mono">{value}</div>
    </div>
  );
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function slugToLabel(s) {
  if (!s) return "—";
  return s.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
